import { render, staticRenderFns } from "./tempPergGajiBiasa(XBPK).vue?vue&type=template&id=85642d68&"
import script from "./tempPergGajiBiasa(XBPK).vue?vue&type=script&lang=js&"
export * from "./tempPergGajiBiasa(XBPK).vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports